export const getExpirationStatus = (expirationDate) => {
  // 🔵 Sin vencimiento (null)
  if (!expirationDate) {
    return {
      colorClass: "bg-blue-500",
      tooltip: "Sin vencimiento",
    };
  }

  const cleanDate = expirationDate.split("T")[0];

  // 🔵 Fecha especial
  if (cleanDate === "1901-01-01") {
    return {
      colorClass: "bg-blue-500",
      tooltip: "Sin vencimiento",
    };
  }

  const expiration = new Date(cleanDate);
  const today = new Date();

  // 🔥 Normalizar (evita bugs por horas)
  today.setHours(0, 0, 0, 0);
  expiration.setHours(0, 0, 0, 0);

  const diffTime = expiration - today;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  // Convertimos meses a días (aprox)
  const sixMonths = 180;
  const twelveMonths = 365;

  // 🔴 ≤ 6 meses (incluye vencidos)
  if (diffDays <= sixMonths) {
    return {
      colorClass: "bg-red-600",
      tooltip:
        diffDays < 0
          ? `Vencido: ${expiration.toLocaleDateString("es-CO")}`
          : `Vence en menos de 6 meses: ${expiration.toLocaleDateString("es-CO")}`,
    };
  }

  // 🟡 > 6 y ≤ 12 meses
  if (diffDays <= twelveMonths) {
    return {
      colorClass: "bg-yellow-400",
      tooltip: `Vence entre 6 y 12 meses: ${expiration.toLocaleDateString("es-CO")}`,
    };
  }

  // 🟢 > 12 meses
  return {
    colorClass: "bg-green-500",
    tooltip: `Vence en más de 1 año: ${expiration.toLocaleDateString("es-CO")}`,
  };
};